import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    meta: {
      title: "Slot",
    },
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/index/index.vue"),
  },
  {
    path: "/bonusgame/:totalBet",
    name: "bonusgame",
    meta: {
      title: "Bonus Game",
    },
    component: () =>
      import(/* webpackChunkName: "bonusgame" */ "@/views/bonusgame/index.vue"),
  }
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach(({ meta }, from, next) => {
  next();
  meta && (document.title = meta.title);
});

export default router;
